export default __webpack_public_path__ + "static/media/portfolio_3.d632b0ae.png";